export default __webpack_public_path__ + "static/media/activity-8.8f2b9738.png";